module.exports = __webpack_public_path__ + "img/logo.a45fbdc5.svg";